import {
    getInfoSchool,
    getSchoolList,
    setCurrentSchoolIdInStorage,
    addTeacher,
    removeTeacher,
    addAssistant,
    removeAssistant,
    getAttendanceTeachers,
    updateSchool,
    updateSchoolFromLocalStorage,
    toggleTrialEnabled,
} from '../../../services/SchoolService.js';

export default {
    /** Load available schools from GET /school (returns single school or array). */
    async loadMySchools(context) {
        const token = context.rootGetters['auth/getToken'];
        if (!token) return [];
        const response = await getSchoolList(token);
        const data = response.data || {};
        const schools = data.schools
            ? [...data.schools]
            : data.school
                ? [data.school]
                : [];
        context.commit('setSchools', { schools });
        return schools;
    },
    async setCurrentSchool(context, schoolId) {
        context.commit('setCurrentSchoolId', schoolId);
        setCurrentSchoolIdInStorage(schoolId);
        const token = context.rootGetters['auth/getToken'];
        const schoolData = await getInfoSchool(token, { schoolId, forceLoad: true });
        context.commit('setInfoSchool', { infoSchool: schoolData.data.school });
        localStorage.setItem('school', JSON.stringify(schoolData.data.school));
        context.commit('students/clearData', null, { root: true });
        context.commit('subscriptions/clearData', null, { root: true });
        context.commit('schedule/clearData', null, { root: true });
        context.commit('typesDance/clearData', null, { root: true });
        context.commit('packages/clearData', null, { root: true });
    },
    async getInfoSchool(context, payloadData) {
        const schoolData = await getInfoSchool(payloadData.token, {
            schoolId: payloadData.schoolId,
            forceLoad: payloadData.forceLoad
        });
        context.commit('setInfoSchool', { infoSchool: schoolData.data.school });
        localStorage.setItem('school', JSON.stringify(schoolData.data.school));
    },
    async addTeacher(context, payloadTeacher) {
        await addTeacher(context.rootGetters['school/getSchoolId'], payloadTeacher, context.rootGetters['auth/getToken']);
        await context.dispatch('getInfoSchool', {token: context.rootGetters['auth/getToken'], forceLoad: true});
    },
    async removeTeacher(context, payloadTeacher) {
        await removeTeacher(context.rootGetters['school/getSchoolId'], payloadTeacher, context.rootGetters['auth/getToken']);
        await context.dispatch('getInfoSchool', {token: context.rootGetters['auth/getToken'], forceLoad: true});
    },
    async addAssistant(context, payloadAssistant) {
        await addAssistant(context.rootGetters['school/getSchoolId'], payloadAssistant, context.rootGetters['auth/getToken']);
        await context.dispatch('getInfoSchool', {token: context.rootGetters['auth/getToken'], forceLoad: true});
    },
    async removeAssistant(context, payloadAssistant) {
        await removeAssistant(context.rootGetters['school/getSchoolId'], payloadAssistant, context.rootGetters['auth/getToken']);
        await context.dispatch('getInfoSchool', {token: context.rootGetters['auth/getToken'], forceLoad: true});
    },
    async getAttendanceTeachers(context) {
        const attendanceTeachers = await getAttendanceTeachers(context.rootGetters['school/getSchoolId'], context.rootGetters['auth/getToken']);
        context.commit('setAttendanceTeachers', attendanceTeachers.data.attendaceStats);
    },
    async updateSchool(context, payloadData) {
        const response = await updateSchool(payloadData, context.rootGetters['school/getSchoolId'], context.rootGetters['auth/getToken']);
        updateSchoolFromLocalStorage(response.data.schoolUpdated);
        context.commit('setInfoSchool', {infoSchool: response.data.schoolUpdated});
    },
    async toggleTrialEnabled(context, trialEnabled) {
        const schoolId = context.rootGetters['school/getSchoolId'];
        const token = context.rootGetters['auth/getToken'];
        const response = await toggleTrialEnabled(schoolId, trialEnabled, token);
        updateSchoolFromLocalStorage(response.data.school);
        context.commit('setInfoSchool', { infoSchool: response.data.school });
    },
    removeInfoSchool(context) {
        localStorage.removeItem('school');
        setCurrentSchoolIdInStorage(null);
        context.commit('setInfoSchool', { infoSchool: null });
        context.commit('setCurrentSchoolId', null);
        context.commit('setSchools', { schools: [] });
    }
}